import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var PageRedirectQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query pageRedirectQuery($pagePath: String = \"\") {\n    pageRedirect(originUri: $pagePath) {\n      originUri\n      redirectUri\n    }\n  }\n"])));
export default PageRedirectQuery;